import React from "react";
import "./Footer.css";
import logo from "../../assets/agentscrum-logo-elixirclaw.svg";
const FooterSection = () => {
  return (
    <footer>
      <div className="footer__wrapper">
        <div className="container">
          <div className="footer-inner">
            <div className="footer-items">
              <div className="footer-logo">
                <img src={logo} alt="agent-scrum-logo" />
              </div>
              <div className="row">
                <div className="list-name">
                  <p>
                    Agent Scrum empowers agile teams with agentic AI to automate
                    sprint planning, task tracking, and retrospectives—boosting
                    productivity, collaboration, and delivery velocity across
                    your development lifecycle.
                  </p>
                </div>
              </div>
            </div>
            <div className="footer-end">
              <div className="row" style={{ alignItems: "center" }}>
                <div className="col-sm-7 col-md-7 col-lg-7">
                  <div className="footer-links">
                    <p>Legal</p>
                    <p>Privacy Policy</p>
                    <p>Terms & Conditions</p>
                  </div>
                </div>
                <div className="col-sm-5 col-md-5 col-lg-5 copyright">
                  <p>Copyright 2026. All rights reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
